export const LABEL_SIZE_RESPONSE = 13.5;
export const LABEL_OPACITY_RESPONSE = 16;

export function labelTransitionFactor(delta: number, response: number) {
  const clampedDelta = Math.min(Math.max(delta, 0), 0.1);
  return 1 - Math.exp(-clampedDelta * response);
}
